export enum AppSnackbarTypeEnum {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
    Info = 'info',
}
